import React from 'react';

const Card = ({ 
  children, 
  variant = 'default',
  className = '',
  padding = true,
  onClick
}) => {
  const baseClasses = 'transition-smooth';
  
  const variantClasses = {
    default: 'card',
    elevated: 'card-elevated',
    gradient: 'card-gradient'
  };
  
  const paddingClass = padding ? '' : '!p-0';
  const clickableClass = onClick ? 'cursor-pointer hover:shadow-medium' : '';
  
  return (
    <div
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${paddingClass} ${clickableClass} ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
